import React from 'react';
import { Stack, Skeleton, Typography, Box } from '@mui/material';

const AssignmentSkeletonList = ({ count = 6, title }) => {
  return (
    <Box>
      {title && (
        <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
          {title}
        </Typography>
      )}
      <Stack spacing={1}>
        {[...Array(count)].map((_, i) => (
          <Skeleton
            key={i}
            variant="rectangular"
            height={40}
            sx={{
              borderRadius: 1.5,
              bgcolor: 'action.hover'
            }}
          />
        ))}
      </Stack>
    </Box>
  );
};

export default AssignmentSkeletonList;